import { Component } from "react";
import "./Purchase.css";
import { AiFillCheckCircle } from "react-icons/ai";
import { GiShoppingCart } from "react-icons/gi";
import axios from "axios";

class Purchase extends Component {
    state = {
        currency: "USD",
        isLoading: false,
        products: [
            {
                productId: "small_pkg",
                stripeId: "prod_NiWOkK5eRU9w24",
                playId: "small_pkg",
                value: "2",
                credits: "100",
                name: "S",
                storageDuration: "6 months",
                currency: "USD",

            },
            {
                productId: "medium_pkg",
                stripeId: "prod_NiWOlGnh9zKbgY",
                playId: "medium_pkg",
                value: "5",
                credits: "300",
                name: "M",
                storageDuration: "6 months",
                currency: "USD",
            },
            {
                productId: "large_pkg",
                stripeId: "prod_NiWO7veE3cwG26",
                playId: "large_pkg",
                value: "10",
                credits: "700",
                name: "L",
                storageDuration: "6 months",
                currency: "USD",
            },
            {
                productId: "extra_large_pkg",
                stripeId: "prod_NiWOscdurm9bWz",
                playId: "extraLarge_pkg",
                value: "50",
                credits: "4000",
                name: "XL",
                storageDuration: "12 months",
                currency: "USD",
            }
        ]
    }

    initiatePayment = async (productId) => {
        const productInfo = this.state.products.filter(item => item.productId === productId)[0]
        if ("getDigitalGoodsService" in window) {
            try {
                await window.getDigitalGoodsService("https://play.google.com/billing");
                this.handlePlayPayment(productInfo)
            } catch (error) {
                this.handleStripePayment(productInfo)
            }

        } else {
            this.handleStripePayment(productInfo)
        }
    }

    handlePlayPayment = async (productInfo) => {
        try {
            const service = await window.getDigitalGoodsService("https://play.google.com/billing");
            if (service) {
                const paymentMethods = [
                    {
                        supportedMethods: "https://play.google.com/billing",
                        data: { sku: productInfo.playId },
                    }
                ];
                const request = new PaymentRequest(paymentMethods);
                const paymentResponse = await request.show();
                const { purchaseToken } = paymentResponse.details;
                this.setState({ isLoading: true })
                const data = {
                    purchaseToken: purchaseToken,
                    productId: productInfo.playId
                }
                axios.post(`${process.env.REACT_APP_BACKEND}/verify-play-purchase`, data,
                    {
                        headers: {
                            Authorization: `Bearer ${this.props.token}`
                        }
                    })
                    .then(async (response) => {
                        await paymentResponse.complete('success');
                        alert("Payment Successful! Enjoy Your Credits!");
                        await this.props.updateUser(response.data.user);
                        this.setState({ isLoading: false })
                        this.props.onClose();
                    })
                    .catch(async (error) => {
                        await paymentResponse.complete('fail');
                        this.setState({ isLoading: false })
                        alert("Payment aknowledgement failed. If the issue persists, please contact our support team at artblast@scifork.com.")
                    })
            }
        } catch (error) {
            alert(`Payment request failed. If the issue persists, please contact our support team at artblast@scifork.com.`);
            this.setState({ isLoading: false })
        }

    }

    handleStripePayment = (productInfo) => {

        // STRIPE payment
        this.setState({ isLoading: true });
        const data = {
            product_id: productInfo.stripeId,
        }
        axios.post(`${process.env.REACT_APP_BACKEND}/create-checkout-session`, data,
            {
                headers: {
                    Authorization: `Bearer ${this.props.token}`
                }
            })
            .then(async (response) => {
                window.location.replace(response.data.url)
            })
            .catch(function (error) {
                console.log(error)
            })
    }

    async componentDidMount() {
        this.setState({ isLoading: false });

        if ("getDigitalGoodsService" in window) {
            const service = await window.getDigitalGoodsService("https://play.google.com/billing");
            const products = [...this.state.products];
            for (let i = 0; i < products.length; i++) {
                const itemDetails = await service.getDetails([products[i].productId]);
                for (const item of itemDetails) {
                    products[i].value = Number(item.price.value).toFixed(2);
                    products[i].currency = item.price.currency;
                }
            }

            this.setState({ products: products });

        }

        // if (productInfo.productId === "medium_pkg") {
        //     const itemDetails = await service.getDetails(['small_pkg', 'product_3']);
        //     for (const item of itemDetails) {
        //         // Display item information to user
        //         alert(`${item.itemId}`);
        //     }
        // }
    }

    render() {
        return (
            <div
                className="card-modal"
                style={{ display: this.props.open ? "block" : "none" }}
            >
                <div className="card-container">
                    {this.state.products.map((item, key) =>
                        <div className="card-content" key={key}>
                            <span className="close" onClick={this.props.onClose}>&times;</span>
                            <br></br>
                            <div className="card-title">Credits Package {item.name}</div>
                            <p className="card-subtitle">Single payment</p>

                            <p className="price">{item.value} <span className="currency">{item.currency}</span> </p>
                            <div className="feats-container">
                                <div className="feats_item">
                                    <AiFillCheckCircle className="icon-check" size={15} />
                                    <div className="feats-item-content">{item.credits} ArtBlast credits.</div>
                                </div>
                                <div className="feats_item">
                                    <AiFillCheckCircle className="icon-check" size={15} />
                                    <div className="feats-item-content">Cloud storage for up to {item.credits} images for {item.storageDuration}.</div>
                                </div>
                            </div>

                            <button
                                disabled={this.state.isLoading}
                                className="checkout"
                                onClick={this.initiatePayment.bind(this, item.productId)}>
                                <GiShoppingCart style={{ verticalAlign: "middle" }} size={22} /> Purchase
                            </button>
                        </div>
                    )}
                </div>
            </div>
        )
    }
}

export default Purchase;